import {
  answerQuestionAnonymous,
  deleteAnswerAnonymous,
} from "./answerQuestionAnonymous";
import { answerQuestion, deleteAnswer } from "./CvpAnswerQuestion";
import { getAnswers } from "./CvpGetAnswers";
import { getQuestionForm } from "./CvpGetQuestionForm";
import { getQuestionFormLogs } from "./CvpGetQuestionFormLogs";
import { getQuestionFormLogState } from "./CvpGetQuestionFormLogState";
import { initiateQuestionForm } from "./CvpInitiateQuestionForm";
import { getAnswersAnonymous } from "./getAnswersAnonymous";
import { getQuestionFormAnonymous } from "./getQuestionFormAnonymous";
import { getQuestionFormLogAnonymous } from "./getQuestionFormLogAnonymous";
import { getQuestionFormsForCase } from "./getQuestionFormsForCase";
import { updateSubmittedAnonymous } from "./updateSubmittedAnonymous";

export const questionForAPI = {
  getQuestionFormsForCase,
  getQuestionForm,
  initiateQuestionForm,
  getQuestionFormLogs,
  answerQuestion,
  getQuestionFormLogState,
  getAnswers,
  deleteAnswer,
  getQuestionFormAnonymous,
  answerQuestionAnonymous,
  getAnswersAnonymous,
  getQuestionFormLogAnonymous,
  updateSubmittedAnonymous,
  deleteAnswerAnonymous,
};

export type QuestionFormAPI = typeof questionForAPI;
